import React from 'react';

import { Wrapper, Label } from './styled/WordsDetectionEmptyStateStyled';

import Icon from '../../Icon';

interface LocalizationLike {
    getText: (key: string) => string;
}

function EmptyState(props: { localization: LocalizationLike }) {
    return (
        <Wrapper>
            <Label>
                <div>{props.localization.getText('trainer.blacklist.summary.empty_state.line_1')}</div>
                <div>{props.localization.getText('trainer.blacklist.summary.empty_state.line_2')}</div>
            </Label>
            <Icon name="TripleThumbsUp" size={80} />
        </Wrapper>
    );
}

export default EmptyState;
